/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSchedulingDateAvailability} from '../api'

 export const useQueryGetSchedulingDateAvailability = createReactQueryHook('getSchedulingDateAvailability', getSchedulingDateAvailability)
